package rendering

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.compose.ui.graphics.Color
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

/** Drives the board-border lock-flash effect. */
class LockFlashState {
    private var _color by mutableStateOf<Color?>(null)
    val color: Color? get() = _color

    fun trigger(scope: CoroutineScope) {
        scope.launch {
            _color = Color(0xFF00E5FF)  // cyan flash
            delay(120L)
            _color = null
        }
    }
}
